import { createRouter, createWebHistory, RouterView } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import Translation from '@/i18n/translation'

const defaultMeta = {
  title: 'Zukunftsbarometer Regensburg',
  description: 'Das Nachhaltigkeitsmonitoring für die UNESCO Welterbe-Stadt Regensburg.'
}

const router = createRouter({
  history: createWebHistory(import.meta.env.VITE_BASE_URL),
  routes: [
    {
      path: '/:locale?',
      component: RouterView,
      beforeEnter: Translation.routeMiddleware,
      children: [
        // DEUTSCH
        {
          path: '',
          name: 'de.home',
          component: HomeView,
          meta: {
            title: 'Zukunftsbarometer Regensburg',
            description: 'Das Nachhaltigkeitsmonitoring für die UNESCO Welterbe-Stadt Regensburg.'
          }
        },
        {
          path: 'kontakt',
          name: 'de.contact',
          component: () => import('../views/ContactView.vue'),
          meta: {
            title: 'Kontakt – Zukunftsbarometer Regensburg',
            description: 'Kontaktdaten und Ansprechpartner des Zukunftsbarometers Regensburg.'
          }
        },
        {
          path: 'download',
          name: 'de.download',
          component: () => import('../views/DownloadView.vue'),
          meta: {
            title: 'Download – Zukunftsbarometer Regensburg',
            description: 'Laden Sie Daten, Berichte und Materialien vom Zukunftsbarometer Regensburg herunter.'
          }
        },
        {
          path: 'datenschutz',
          name: 'de.privacy',
          component: () => import('../views/PrivacyView.vue'),
          meta: {
            title: 'Datenschutz – Zukunftsbarometer Regensburg',
            description: 'Informationen zum Datenschutz beim Zukunftsbarometer Regensburg.'
          }
        },
        {
          path: 'impressum',
          name: 'de.imprint',
          component: () => import('../views/ImprintView.vue'),
          meta: {
            title: 'Impressum – Zukunftsbarometer Regensburg',
            description: 'Rechtliche Angaben und Impressum des Zukunftsbarometers Regensburg.'
          }
        },

        // ENGLISH
        {
          path: '',
          name: 'en.home',
          component: HomeView,
          meta: {
            title: 'Zukunftsbarometer Regensburg',
            description: 'Sustainability monitoring for the UNESCO World Heritage City of Regensburg'
          }
        },
        {
          path: 'contact',
          name: 'en.contact',
          component: () => import('../views/ContactView.vue'),
          meta: {
            title: 'Contact – Zukunftsbarometer Regensburg',
            description: 'Contact details and key contacts for Zukunftsbarometer Regensburg.'
          }
        },
        {
          path: 'download',
          name: 'en.download',
          component: () => import('../views/DownloadView.vue'),
          meta: {
            title: 'Download – Zukunftsbarometer Regensburg',
            description: 'Download data, reports, and materials from Zukunftsbarometer Regensburg.'
          }
        },
        {
          path: 'privacy',
          name: 'en.privacy',
          component: () => import('../views/PrivacyView.vue'),
          meta: {
            title: 'Privacy – Zukunftsbarometer Regensburg',
            description: 'Privacy policy information for Zukunftsbarometer Regensburg.'
          }
        },
        {
          path: 'imprint',
          name: 'en.imprint',
          component: () => import('../views/ImprintView.vue'),
          meta: {
            title: 'Imprint – Zukunftsbarometer Regensburg',
            description: 'Legal notice and imprint of Zukunftsbarometer Regensburg.'
          }
        },

        // EMBED (shared)
        {
          path: 'embed/:id',
          name: 'embed',
          component: () => import('../views/EmbedView.vue'),
          meta: {
            title: 'Embed Content – Zukunftsbarometer Regensburg',
            description: 'Embedded content from the Zukunftsbarometer Regensburg platform.'
          }
        }
      ]
    },

    // REDIRECTS
    { path: '/en/kontakt', redirect: { path: '/en/contact' } },
    { path: '/en/impressum', redirect: { path: '/en/imprint' } },
    { path: '/en/datenschutz', redirect: { name: 'en.privacy' } },
    { path: '/contact', redirect: { name: 'de.contact' } },
    { path: '/imprint', redirect: { name: 'de.imprint' } },
    { path: '/privacy', redirect: { name: 'de.privacy' } }
  ]
})

// global hook: set <title> and <meta name="description">
router.afterEach((to) => {
  const title = to.meta.title || defaultMeta.title
  document.title = title

  const desc = to.meta.description || defaultMeta.description
  let tag = document.querySelector('meta[name="description"]')
  if (tag) {
    tag.setAttribute('content', desc)
  } else {
    tag = document.createElement('meta')
    tag.setAttribute('name', 'description')
    tag.setAttribute('content', desc)
    document.head.appendChild(tag)
  }
})

export default router
